import { setShowPersonalizationBarAction } from 'editor/src/store/editorModules/preview/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import getHostSetting from 'editor/src/store/hostSettings/selector/getHostSetting';
import { RootState } from 'editor/src/store/index';

import requestPreviewsOperation from './requestPreviewsOperation';

const openAIPersonalizationPreviewOperation = () => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const state = getState();
  const previewType = getHostSetting(state, 'previewType');

  dispatch(setShowPersonalizationBarAction(true));
  dispatch(requestPreviewsOperation(previewType));
};

export default openAIPersonalizationPreviewOperation;
